import {useTranslation} from "react-i18next";
import {isRouteErrorResponse, useRouteError} from "react-router-dom";

import {useCheckPermissionAdmin} from "../hooks/permissionHooks";
import {selectDevelopMode} from "../redux/envSlice";
import {useRevaSelector} from "../redux/revaHooks";
import Header from "./Header";
import {Sidebar} from "./Sidebar";

function PageErrorDetails() {
    const error = useRouteError();
    const errorObject = error instanceof Error ? error : null;

    const isAdmin = useCheckPermissionAdmin();
    const isDevelop = useRevaSelector(selectDevelopMode);

    if ((!isAdmin && !isDevelop) || !errorObject) {
        return null;
    }

    return (
        <div
            style={{
                backgroundColor: "rgb(68,5,12)",
                color: "rgb(252, 207, 207)",
                padding: "1rem",
                marginTop: "2rem",
            }}
        >
            <div
                style={{
                    color: "rgb(232, 59, 70)",
                    fontSize: "1.2em",
                    marginBottom: "1rem",
                    fontFamily: "sans-serif",
                }}
            >
                {errorObject.message}
            </div>

            <pre>{errorObject.stack}</pre>
        </div>
    );
}

function PageError() {
    const {t, i18n} = useTranslation();

    const error = useRouteError();
    console.error(error);

    const routeError = isRouteErrorResponse(error) ? error : null;
    const errorObject = error instanceof Error ? error : null;

    let errorToDisplay = routeError?.statusText || errorObject?.message;
    let errorDescriptionToDisplay: string | null = null;
    if (routeError && i18n.exists(`error.${routeError.status}`)) {
        errorToDisplay = t(`error.${routeError.status}`);
        errorDescriptionToDisplay = t(`error.${routeError.status}Description`);
    }

    return (
        <main className="grow pt-4 px-6 py-6 w-full">
            <div className="flex flex-col w-full h-full">
                <h2 className="flex mt-0">
                    <div className="HeaderText">
                        {t("error.error")}: {errorToDisplay}
                    </div>
                </h2>
                <p>
                    <strong>{t("error.anErrorOccurred")}</strong>
                </p>
                <p>
                    <i>{errorDescriptionToDisplay}</i>
                </p>
                <PageErrorDetails />
            </div>
        </main>
    );
}

export default function AppError() {
    return (
        <>
            <Header />
            <div className="MainView grow shrink-0">
                <div className="flex flex-row w-full h-full">
                    <Sidebar />
                    <PageError />
                </div>
            </div>
        </>
    );
}
